




























import Vue, { PropOptions } from 'vue'
import '../../styles/view-tile.css'
import '../../styles/user-alert-list.css'
import { Alerts } from '../../dataLayer/Alerts'
import IAlert from '../../viewModel/IAlert'
import AlertThumbnail from './AlertThumbnail.vue'

interface IData {
  removeItem: IAlert
  showRemoveModal: boolean
  showRemoveErrorModal: boolean
  alerts: IAlert[]
  isAdmin: boolean
  loading: boolean
}

export default Vue.extend({
  components: { AlertThumbnail },
  name: 'UserAlertList',
  data: function (): IData {
    return {
      removeItem: {} as IAlert,
      showRemoveModal: false,
      showRemoveErrorModal: false,
      alerts: [] as IAlert[],
      isAdmin: false,
      loading: true,
    }
  },
  mounted: async function (): Promise<void> {
    await this.loadData()
    this.$root.$on('alerts-modified', () => {
      this.loadData()
    })
  },
  props: {
    tags: {
      type: Array,
      required: true,
    },
    alertTags: { type: Array, required: true } as PropOptions<
      { id: string; name: string }[]
    >,
    showAll: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    tags: async function () {
      await this.loadData()
    },
  },
  methods: {
    loadData: async function () {
      this.loading = true
      const viewModel = await Alerts.loadAlerts(
        this.tags as number[],
        false,
        !this.showAll
      )
      this.alerts = viewModel.alerts
      this.isAdmin = viewModel.isAdmin
      this.loading = false
    },
  },
})
